export const faqItems = [
  {
    id: 1,
    question: '爱爱网是一个什么样的平台？',
    answer: '爱爱网是专注于成人情感与亲密关系的专业交流平台。我们致力于提供科学、健康、负责任的两性情感知识，涵盖情感咨询、两性健康、伴侣沟通、亲密关系和个人成长等多个领域。所有内容均由资深心理咨询师、医学专家和两性关系研究者撰写或审核，确保信息的专业性和可靠性。',
  },
  {
    id: 2,
    question: '爱爱网的内容是否适合所有成年人阅读？',
    answer: '是的，我们的内容面向所有成年读者。我们以科学、理性的态度讨论两性话题，避免低俗和不恰当的内容表达。无论是正在恋爱中的年轻人、已婚多年的伴侣，还是希望提升自我情感智慧的个人，都能在这里找到有价值的信息。我们建议读者根据自身情况选择性阅读相关内容。',
  },
  {
    id: 3,
    question: '如何预约一对一的情感咨询服务？',
    answer: '目前爱爱网以内容分享和社区交流为主。如果您需要专业的一对一情感咨询，可以通过我们的联系表单提交需求，我们会根据您的情况推荐经过严格筛选的专业心理咨询师。所有推荐的咨询师均持有国家认可的心理咨询资质。',
  },
  {
    id: 4,
    question: '我可以在爱爱网上发表自己的文章或分享经验吗？',
    answer: '我们欢迎社区成员投稿和分享自己的真实经历与感悟。所有投稿需经过编辑团队的审核，确保内容真实、健康、具有建设性。投稿前请仔细阅读我们的内容指南和社区规范。您可以通过网站底部的"投稿合作"链接了解详细的投稿流程。',
  },
  {
    id: 5,
    question: '爱爱网如何保护用户隐私？',
    answer: '用户隐私是我们的首要关注。爱爱网采用严格的数据保护措施，所有用户信息均经过加密处理。我们承诺不会在未经用户明确同意的情况下将任何个人信息分享给第三方。具体请查阅我们的隐私政策页面了解详细信息。',
  },
  {
    id: 6,
    question: '网站上的情感文章是否有科学依据？',
    answer: '爱爱网的所有内容均基于心理学、医学等科学研究成果编写。我们的撰稿团队包括持有专业资质的心理咨询师、医学博士和两性关系研究者。每篇文章都会经过至少两轮专业审核，确保信息的科学性和准确性。文章中引用的研究和数据来源会在文末标注。',
  },
  {
    id: 7,
    question: '如何参与爱爱网的线下活动？',
    answer: '爱爱网定期在各大城市举办线下讲座、工作坊和交流会。活动信息会提前在网站的活动页面和我们的社交媒体账号上发布。您可以关注我们的微信公众号或订阅邮件通知，第一时间获取活动资讯。部分热门活动的名额有限，建议提前报名。',
  },
];